import { ModifierDetail } from './modifier-detail';

export class ProductModifier {
	productModifierId: number;
	productId: number;
	productType: string;
	modifierId: number;
	modifierName: string;
	modifierType: string;
	modifierDetails: ModifierDetail[];
	priceAdjustment: number;
	quantity: number;
	isUndefinedPrice: boolean;
	isNegativeUndefinedPrice: boolean;
	customPrice: number;
	isRequireSelection: boolean;
}
